import { useEffect, useState } from "react";
import '../common/style.css';
import { useLocation } from 'react-router-dom';

export default function DisplayImageComponent() {
    const baseUrl = "https://erp.apitco.org:8092/cloud/displayImage?version=v1&keyName=";
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    
    const fileName = queryParams.get('keyName');
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
        if (fileName) {
            setImageUrl(baseUrl + fileName);
        }
    }, [fileName]);

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 text-center mt-4">
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            className="img-fluid rounded shadow"
                            alt="S3 File"
                            style={{ maxHeight: "500px" }}
                        />
                    ) : (
                        <p>No image selected. Please provide a valid keyName parameter.</p>
                    )}
                </div>
            </div>
        </div>
    );
}
